import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserProfile } from '../models/profile.interface';

@Injectable({ providedIn: 'root' })
export class ProfileStateService {
  private avatarUrl$ = new BehaviorSubject<string | null>(null);
  private initials$ = new BehaviorSubject<string>('');
  private name$ = new BehaviorSubject<string | null>(null);

  readonly avatarUrl = this.avatarUrl$.asObservable();
  readonly initials = this.initials$.asObservable();
  readonly name = this.name$.asObservable();

  setProfile(profile: UserProfile): void {
    this.avatarUrl$.next(profile.avatarUrl);
    this.initials$.next(profile.initials);
    this.name$.next(profile.name);
  }

  updateAvatarUrl(url: string): void {
    this.avatarUrl$.next(url);
  }

  updateName(name: string): void {
    this.name$.next(name);
  }
}
